import { useCallback, useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Card, Empty, PageHeader } from "@/components/app/StatusBadge";
import { BotForm } from "@/components/bot/BotForm";
import { BotCard, BOT_ACTIVE } from "@/components/bot/BotCard";
import { api } from "@/lib/api";
import { useApp } from "@/lib/i18n";
import { UpgradeLock } from "@/components/billing/UpgradeLock";
import { hasBot } from "@/config/plans";
import { useAuth } from "@/context/AuthContext";

export default function BotPage() {
  const { L } = useApp();
  const { workspace } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [bots, setBots] = useState([]);
  const load = useCallback(() => workspace && api.get("/bots", { params: { workspace_id: workspace.id } }).then((r) => setBots(r.data)), [workspace]);
  useEffect(() => { api.get("/bots/config").then((r) => setCfg(r.data)); load(); }, [load]);
  const active = bots.some((b) => BOT_ACTIVE.includes(b.status));
  useEffect(() => {
    if (!active) return;
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, [active, load]);
  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-8" data-testid="bot-page">
      <PageHeader title={L("Mesyuarat Online", "Online Meeting")} desc={L("Hantar \"MinitAI Pencatat\" ke Zoom, Google Meet atau Teams. Bot merakam audio, kemudian transkrip dan dokumen pilihan anda dijana secara automatik.", "Send \"MinitAI Pencatat\" to Zoom, Google Meet or Teams. It records audio, then the transcript and your chosen document are generated automatically.")} />
      {cfg && !cfg.configured && (
        <div className="mt-6 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800" data-testid="bot-not-configured">
          <AlertTriangle size={18} className="mt-0.5 shrink-0" />
          <span>{L("Mesyuarat Online belum dikonfigurasi. Pentadbir perlu menetapkan kunci API Recall.ai di pelayan.", "Meeting bot is not configured. An admin needs to set the Recall.ai API key on the server.")}</span>
        </div>
      )}
      {hasBot(workspace)
        ? <Card className="mt-6 p-6"><BotForm configured={!!cfg?.configured} onSent={load} /></Card>
        : <div className="mt-6"><UpgradeLock testId="bot-lock" title={L("Mesyuarat Online: Zoom, Meet & Teams", "Online Meeting: Zoom, Meet & Teams")} label={L("Naik taraf ke Pro — RM39.90/bulan", "Upgrade to Pro — RM39.90/month")} desc={L("Bot \"MinitAI Pencatat\" tersedia pada pelan Pro dan Team Asas. Ia menyertai mesyuarat, merakam dan menjana dokumen secara automatik.", "The \"MinitAI Pencatat\" bot is available on Pro and Team. It joins meetings, records and generates documents automatically.")} /></div>}
      <h2 className="mt-8 mb-3 font-semibold">{L("Bot terkini (7 hari)", "Recent bots (7 days)")}</h2>
      <div className="space-y-3" data-testid="bot-list">
        {bots.length ? bots.map((m) => <BotCard key={m.id} meeting={m} canWrite onChange={load} showLink />)
          : <Empty testId="bot-list-empty">{L("Belum ada bot dihantar.", "No bots sent yet.")}</Empty>}
      </div>
    </div>
  );
}
